import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium bg-secondary-100 text-secondary-800 rounded-full mb-3">
            话题中心
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            热门话题
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            探索最受关注的漫画话题与分类
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.map((topic, idx) => (
            <a
              key={idx}
              href={topic.href}
              className="group flex items-center gap-2 px-5 py-2.5 bg-background-100 rounded-full border border-background-200 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer no-underline"
            >
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 whitespace-nowrap">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-200 group-hover:bg-primary-100 group-hover:text-primary-500 px-2 py-0.5 rounded-full whitespace-nowrap transition-colors">
                {topic.count.toLocaleString()}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}